var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content", attrs: { id: "AIKnowledgeCreateForm" } },
    [
      _c("div", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.questionItemTexts,
            expression: "questionItemTexts",
          },
        ],
        attrs: { type: "text", disabled: true },
        domProps: { value: _vm.questionItemTexts },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.questionItemTexts = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("div", [_vm._v("Scenarios")]),
      _vm._v(" "),
      _c(
        "a-select",
        {
          staticClass: "select-story",
          attrs: {
            placeholder: _vm.$t("message.chooseAiStory"),
            "filter-option": false,
          },
          model: {
            value: _vm.selectedStoryId,
            callback: function ($$v) {
              _vm.selectedStoryId = $$v
            },
            expression: "selectedStoryId",
          },
        },
        _vm._l(_vm.filteredStories, function (story) {
          return _c(
            "a-select-option",
            { key: story._id, attrs: { value: story._id } },
            [
              _c("span", { staticClass: "blockTypeText" }, [
                _vm._v(_vm._s(story.title)),
              ]),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.description))]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.answer,
            expression: "answer",
          },
        ],
        domProps: { value: _vm.answer },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.answer = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-container" },
        [
          _c(
            "SupsisButton",
            {
              staticClass: "sup-btn",
              attrs: { primary: "" },
              on: { click: _vm.saveFaq },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.save")))]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }